import $ from 'jquery'

export default {
  backup: (next, route) => {
    var activeState = JSON.parse(localStorage.getItem('state_' + route.name))
    var state = activeState ? activeState : {}

    state.scroll = [0, window.scrollY]
    state.search = $('input[type="search"]').val()
    state.pagination = $('table').DataTable().page.info().page

    localStorage.setItem('state_' + route.name, JSON.stringify(state))
    next()
  },

  restore(route) {
    var state = JSON.parse(localStorage.getItem('state_' + route.name))
    var table = $('table').DataTable()

    if (!state) return

    if (state['scroll']) window.scrollTo(...state.scroll)
    if (state['search']) table.search(state.search).draw()
    if (state['order']) table.order(state.order).draw()
    if (state['pagination']) table.page(state.pagination).draw('page')

  },

  filtersBackup(route, table) {
    $('table').on('order.dt', () => {
      var order = table.order()
      var column = order[0][0]
      var method = order[0][1]

      if (!_.isNumber(column) || !method) return

      var activeState = JSON.parse(localStorage.getItem('state_' + route.name))
      var state = activeState ? activeState : {}
      state.order = [column, method]

      localStorage.setItem('state_' + route.name, JSON.stringify(state))
    })
  },

  getItemObject(label) {
    return localStorage.getItem(label);
  },

  getItem(label) {
    return JSON.parse(localStorage.getItem(label));
  },
  setItem(label, value) {
    return localStorage.setItem(label, JSON.stringify(value));
  }
}



// WEBPACK FOOTER //
// ./src/plugins/page-state.js